"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TikTokAdvertiserService = void 0;
class TikTokAdvertiserService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of campaigns of an advertiser
     * @param id
     * @param page
     * @param count
     * @param advertiserId
     * @returns TikTokCampaigns
     * @throws ApiError
     */
    advertiserGetCampaigns(id, page, count, advertiserId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/tiktok/campaigns',
            query: {
                'id': id,
                'page': page,
                'count': count,
                'advertiserId': advertiserId,
            },
        });
    }
    /**
     * Create a new TikTok campaign for an advertiser
     * @param requestBody
     * @returns TikTokCampaign
     * @throws ApiError
     */
    advertiserCreateCampaign(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/tiktok/campaigns',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a list of offerings of an advertiser
     * @returns TikTokOfferings
     * @throws ApiError
     */
    advertiserGetOfferings() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/tiktok/offerings',
        });
    }
    /**
     * Check if the given campaign name already exists across all the user's accounts
     * @param requestBody
     * @returns TikTokCampaign
     * @throws ApiError
     */
    advertiserCheckCampaignNameExists(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/tiktok/campaign-name-exists',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update an existing TikTok campaign for an advertiser
     * @param campaignId
     * @param requestBody
     * @returns TikTokCampaign
     * @throws ApiError
     */
    advertiserUpdateCampaign(campaignId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/advers/tiktok/campaigns/{campaignId}',
            path: {
                'campaignId': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get deployments of campaign for an advertiser
     * @param campaignId
     * @returns TikTokDeployments
     * @throws ApiError
     */
    advertiserGetDeployments(campaignId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/tiktok/campaigns/{campaignId}/deployments',
            path: {
                'campaignId': campaignId,
            },
        });
    }
    /**
     * Get a deployment by id
     * @param deploymentId
     * @returns TikTokDeployment
     * @throws ApiError
     */
    advertiserGetDeploymentById(deploymentId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/tiktok/deployments/{deploymentId}',
            path: {
                'deploymentId': deploymentId,
            },
        });
    }
    /**
     * Return a thumbnail of a creative
     * @param deploymentId
     * @param uid
     * @returns any Successful response
     * @throws ApiError
     */
    advertiserGetCreativeThumbnail(deploymentId, uid) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/tiktok/deployments/{deploymentId}/creative/thumbnail/{uid}',
            path: {
                'deploymentId': deploymentId,
                'uid': uid,
            },
        });
    }
    /**
     * Accept a creative
     * @param deploymentId
     * @returns any Successful response
     * @throws ApiError
     */
    advertiserCreativeAccept(deploymentId) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/tiktok/deployments/{deploymentId}/creative/accept',
            path: {
                'deploymentId': deploymentId,
            },
        });
    }
    /**
     * Reuest changes
     * @param deploymentId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    advertiserCreativeRequestChanges(deploymentId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/tiktok/deployments/{deploymentId}/creative/requestChanges',
            path: {
                'deploymentId': deploymentId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Flag a creative to mark it unusable
     * @param deploymentId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    advertiserCreativeFlag(deploymentId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/tiktok/deployments/{deploymentId}/creative/flag',
            path: {
                'deploymentId': deploymentId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Execute action for a deliverable with result
     * @param deploymentId
     * @param deliverableId
     * @param requestBody
     * @returns SponsorshipDeliverableExecuteActionResponse
     * @throws ApiError
     */
    advertiserExecuteActionWithResult(deploymentId, deliverableId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/tiktok/deployments/{deploymentId}/deliverables/{deliverableId}/executeWithResult',
            path: {
                'deploymentId': deploymentId,
                'deliverableId': deliverableId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a list of offering assets
     * @param offeringId
     * @param page
     * @param count
     * @returns AdvertiserAssetsResponse
     * @throws ApiError
     */
    advertiserGetOfferingAssets(offeringId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/tiktok/offerings/{offeringId}/assets',
            path: {
                'offeringId': offeringId,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Create an asset for an offering
     * @param offeringId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    advertiserCreateOfferingAsset(offeringId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/tiktok/offerings/{offeringId}/assets',
            path: {
                'offeringId': offeringId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get specific offering asset
     * @param offeringId
     * @param id
     * @returns AdvertiserAssetResponse
     * @throws ApiError
     */
    advertiserGetOfferingAsset(offeringId, id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/tiktok/offerings/{offeringId}/assets/{id}',
            path: {
                'offeringId': offeringId,
                'id': id,
            },
        });
    }
    /**
     * Update an asset of an offering
     * @param offeringId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    advertiserUpdateOfferingAsset(offeringId, id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/advers/tiktok/offerings/{offeringId}/assets/{id}',
            path: {
                'offeringId': offeringId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete an asset for an offering
     * @param offeringId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    advertiserDeleteOfferingAsset(offeringId, id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/advers/tiktok/offerings/{offeringId}/assets/{id}',
            path: {
                'offeringId': offeringId,
                'id': id,
            },
        });
    }
    /**
     * Generate an asset upload url for an offering
     * @param offeringId
     * @param requestBody
     * @returns GetFileSignedUrlResponse
     * @throws ApiError
     */
    advertiserGenerateAssetUploadSignedUrl(offeringId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/tiktok/offerings/{offeringId}/assets/generate-asset-upload-signed-url',
            path: {
                'offeringId': offeringId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.TikTokAdvertiserService = TikTokAdvertiserService;
